import React from 'react';
import styled from 'styled-components';
import { SelectableLink, SelectableLinkContainer } from 'components/Link';
import Title from 'components/Title';
import { Text } from 'components/Text';

const Wrapper = styled.div`
  display: grid;
  text-align: center;
`;

const Options = () => {
  return (
    <Wrapper>
      <Title white>Options</Title>
      <SelectableLinkContainer>
        <SelectableLink to="/desktop">Back</SelectableLink>
      </SelectableLinkContainer>
      <Text>Section to be built out.</Text>
    </Wrapper>
  );
};
export default Options;
